"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
 query eventDiscounts($eventId: String, $seasonId: String, $discountCode: String!,$userId: String,$selectedTicket:[String]) {
  eventDiscounts(eventId: $eventId, seasonId: $seasonId, discountCode: $discountCode, userId: $userId,selectedTicket:$selectedTicket) {
    promoType
    active
    startsAt
    endsAt
    remainingQty
    overRideMax
    discountType
    discountValue
    appliesTo
    ticketTypeIds
    selectedTicket
  }
}
`;
exports.default = query;
//# sourceMappingURL=discountCodeVerify.query.js.map